import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { Feedback } from "./components/feedbacks";


export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [language, setLanguage] = useState('RU');
  const [landingPageData, setLandingPageData] = useState({});
  const queryParams = new URLSearchParams(window.location.search);

  useEffect(()=>{
    const languageParam = queryParams.get('l');
    if(languageParam){
      setLanguage(languageParam.toUpperCase())
    }
  },[])

  useEffect(()=>{
    setLandingPageData(JsonData[language]);
  },[language])

  return (
    <div>
      <Navigation data = {{setLanguage, language, navigation: landingPageData.Navigation}}/>
      <Header data={landingPageData.Header} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Feedback data={landingPageData.Feedbacks} />
      <Gallery data={landingPageData.Gallery} />
      <Contact data={{contactData: landingPageData.Contact, servicesData: landingPageData?.Services?.list}} />
    </div>
  );
};

export default App;
